import { Link } from 'react-router-dom'
import { cn } from '@/lib/utils'

const base =
  'inline-flex items-center justify-center gap-2 rounded-full px-7 py-3 text-base font-semibold transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2 focus-visible:ring-offset-cream'

const variants = {
  primary: 'bg-primary-700 text-white shadow-lg hover:bg-primary-800',
  secondary:
    'border border-primary-300 bg-transparent text-primary-800 hover:bg-primary-50',
  light: 'bg-white text-primary-800 shadow-lg hover:bg-cream-50',
  outlineLight:
    'border border-white/70 bg-transparent text-white hover:bg-white/10',
}

export function PillButton({
  to,
  href,
  variant = 'primary',
  className,
  children,
  ...props
}) {
  const cls = cn(base, variants[variant], className)
  if (href) {
    return (
      <a href={href} className={cls} {...props}>
        {children}
      </a>
    )
  }
  return (
    <Link to={to} className={cls} {...props}>
      {children}
    </Link>
  )
}
